








import { Component, Vue } from 'vue-property-decorator'
import helper from '@utils'
@Component({
  props: {
    value: {
      type: Array,
      default: () => []
    },
    timeType: { // 时间划分维度
      type: String,
      required: !0
    },
    minDate: { // 最小可点击日期
      type: [Date, Number],
      default: () => new Date()
    },
    maxDate: { // 最大可点击日期
      type: [Date, Number],
      default: () => new Date()
    }
  }
})
export default class DateNav extends Vue {
  private timeType!: 'day' | 'week' | 'month' | 'year'
  private minDate!: Date | number
  private maxDate!: Date | number
  private value!: Date[]
  private get cmpDatetime() {
    // let datetime = ''
    if (this.timeType === 'day' && this.value[0] && this.value[1]) {
      const calendar = helper.moment(this.value[0].valueOf()).calendar(Date.now(), { sameDay: '[today]', lastDay: '[yesterday]' })
      if (calendar === 'today') {
        return `${helper.dateTimeFormat(this.value[0].valueOf(), 'M月D日')} (今天)`
      } else if (calendar === 'yesterday') {
        return `${helper.dateTimeFormat(this.value[0].valueOf(), 'M月D日')} (昨天)`
      } else {
        return `${helper.dateTimeFormat(this.value[0].valueOf(), 'M月D日')}`
      }
    } else if (this.timeType === 'week' && this.value[0] && this.value[1]) {
      return `${helper.dateTimeFormat(this.value[0].valueOf(), 'M月D日')}至${helper.dateTimeFormat(this.value[1].valueOf(), 'M月D日')}`
    } else if (this.timeType === 'month' && this.value[0] && this.value[1]) {
      return `${helper.dateTimeFormat(this.value[0].valueOf(), 'YYYY年M月')}`
    } else if (this.timeType === 'year' && this.value[0] && this.value[1]) {
      return `${helper.dateTimeFormat(this.value[0].valueOf(), 'YYYY年')}`
    }
  }
  private get cmpLeftArrowCanClick() {
    if (this.value[0] && this.value[1]) {
      if (this.timeType === 'week') {
        if (this.minDate.valueOf() > this.value[0].valueOf() && this.minDate.valueOf() < this.value[1].valueOf()) {
          return !1
        } else {
          return !0
        }
      } else {
        return helper.moment(this.value[0]).isAfter(this.minDate, this.timeType)
      }
    } else {
      return !1
    }
  }
  private get cmpRightArrowCanClick() {
    if (this.value[0] && this.value[1]) {
      if (this.timeType === 'week') {
        if (this.maxDate.valueOf() > this.value[0].valueOf() && this.maxDate.valueOf() < this.value[1].valueOf()) {
          return !1
        } else {
          return !0
        }
      } else {
        return helper.moment(this.value[0]).isBefore(this.maxDate, this.timeType)
      }
    } else {
      return !1
    }
  }
  private prevDate() {
    if (!this.cmpLeftArrowCanClick) {
      return
    }
    this.changeDate('subtract')
  }
  private nextDate() {
    if (!this.cmpRightArrowCanClick) {
      return
    }
    this.changeDate('add')
  }
  private changeDate(type: 'add' | 'subtract') {
    const startTimestamp = this.value[0].valueOf()
    let startDate = new Date()
    let endDate = new Date()
    if (this.timeType === 'day') {
      startDate = helper.moment(startTimestamp)[type](1, 'days').toDate()
      endDate = helper.moment(startDate).endOf('day').toDate()
    } else if (this.timeType === 'week') {
      startDate = helper.moment(startTimestamp).locale('en-ca')[type](1, 'weeks').toDate()
      endDate = helper.moment(startDate).locale('en-ca').endOf('week').toDate()
    } else if (this.timeType === 'month') {
      startDate = helper.moment(startTimestamp)[type](1, 'months').toDate()
      endDate = helper.moment(startDate).endOf('month').toDate()
    } else if (this.timeType === 'year') {
      startDate = helper.moment(startTimestamp)[type](1, 'years').toDate()
      endDate = helper.moment(startDate).endOf('year').toDate()
    }
    this.$emit('input', [startDate, endDate])
  }
}
